














































































































import { Vue, Component } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { schedulerModule } from "@/store/modules/scheduler";
import { RegexCheck } from "@/utils/app-util";
import  http  from "@/http/axios";

@Component
export default class Scehduler extends Vue {
    public dialog = false;
    public headers = [
        {
            text: "Job id",
            align: "start",
            value: "id"
        },
        { text: "func path", value: "func" },
        { text: "trigger", value: "trigger" },
        { text: "next run time", value: "next_run_time"},
        { text: "status", value: "job_status"},
        { text: "Actions", value: "actions", sortable: false }
  ];
  public jobBody = {
      id: null,
      trigger: "cron",
      func: "app.apscheduler:asus_collect",
      args1: null,
      args2: null,
      args3: null,
      month: null,
      day: null,
      day_of_week: null,
      hour: null,
      minute: null,
  };
  get loading() {
      return schedulerModule.loading;
  }

  get jobs_list() {
      return schedulerModule.jobs_list;
  }

  get scheduler_info() {
      return schedulerModule.scheduler_info;
  }

  public editedIndex = -1;

  get formTitle() {
      return this.editedIndex === -1 ? "新增Job" : "修改Job";
  }

  public getcolor(status){
    if (status === "running") return 'green';
    else return 'red';
  }

  has_value(item){
    return (item===null)
      ? false
      : (item===undefined)
        ? false
        : (item==="")
          ? false
          : true;
  }

  editItem(item) {
      this.editedIndex = item.id;
      this.jobBody = Object.assign({}, item);
      if(this.jobBody.func==='app.apscheduler:calculate_users'){
          this.close()
          return;
      }
      this.jobBody.args1 = item.args[1];
      this.jobBody.args2 = item.args[2];
      this.jobBody.args3 = item.args[3];
      this.dialog = true;
  }

  close() {
    this.dialog = false;
    this.jobBody = {
        id: null,
        trigger: "cron",
        func: "app.apscheduler:asus_collect",
        args1: null,
        args2: null,
        args3: null,
        month: null,
        day: null,
        day_of_week: null,
        hour: null,
        minute: null,
    };
    this.editedIndex = -1;
  }

  public testmonth(value) {
      return this.has_value(value)? RegexCheck(value, "month") : true;
  }
  public testday_of_week(value) {
      return this.has_value(value)? RegexCheck(value, "day_of_week"):true;
  }
  public testday(value) {
      return this.has_value(value)? RegexCheck(value, "day"): true;
  }
  public testhour(value) {
      return this.has_value(value)? RegexCheck(value, "hour"):true;
  }
  public testminute(value) {
      return this.has_value(value)? RegexCheck(value, "minute"):true;
  }

  public async save() {
    const param = {};
    if(!this.has_value(this.jobBody.id)||
    !this.has_value(this.jobBody.trigger)||
    !this.has_value(this.jobBody.func)){
        appModule.sendErrorNotice("請完成表單");
        this.close();
        return;
    }
    if((this.jobBody.func === 'app.apscheduler:asus_collect' || this.jobBody.func === 'app.apscheduler:asus_sleep')&&
    (!this.has_value(this.jobBody.args1)||
    !this.has_value(this.jobBody.args2)||
    !this.has_value(this.jobBody.args3))){
        appModule.sendErrorNotice("請完成表單");
        this.close();
        return;
    }
    if(!this.has_value(this.jobBody.month)&&
    !this.has_value(this.jobBody.day)&&
    !this.has_value(this.jobBody.day_of_week)&&
    !this.has_value(this.jobBody.hour)&&
    !this.has_value(this.jobBody.minute)){
        appModule.sendErrorNotice("請完成至少一個crontab欄位");
        this.close();
        return;
    }
    param['func'] = this.jobBody.func;
    param['trigger'] = {
        "type":this.jobBody.trigger
    }
    if(this.has_value(this.jobBody.month)) param['trigger']['month'] = this.jobBody.month;
    if(this.has_value(this.jobBody.day)) param['trigger']['day'] = this.jobBody.day;
    if(this.has_value(this.jobBody.day_of_week)) param['trigger']['day_of_week'] = this.jobBody.day_of_week;
    if(this.has_value(this.jobBody.hour)) param['trigger']['hour'] = this.jobBody.hour;
    if(this.has_value(this.jobBody.minute)) param['trigger']['minute'] = this.jobBody.minute;
    param['args'] = [
        this.jobBody.id
    ];
    if(this.has_value(this.jobBody.args1)) param['args'].push(this.jobBody.args1);
    if(this.has_value(this.jobBody.args2)) param['args'].push(this.jobBody.args2);
    if(this.has_value(this.jobBody.args3)) param['args'].push(this.jobBody.args3);
    if (this.editedIndex === -1){
        param['id'] = this.jobBody.id;
        // schedulerModule.addJob(param);
        schedulerModule.publicSetLoading(true);
        const result = await http.post("/scheduler/jobs/" ,param);
        if(result && result.status === 200) {
            appModule.sendSuccessNotice("新增成功");
        }else{
            appModule.sendErrorNotice("新增失敗");
        }
        schedulerModule.publicSetLoading(true);
        schedulerModule.initialScheduler();
    }else{
        // schedulerModule.modifyJob(this.jobBody.id, param);
        schedulerModule.publicSetLoading(true);
        const result = await http.patch("/scheduler/jobs/" + this.jobBody.id, param);
        if(result && result.status === 200) {
            appModule.sendSuccessNotice("修改成功");
        }else{
            appModule.sendErrorNotice("修改失敗");
        }
        schedulerModule.publicSetLoading(true);
        schedulerModule.initialScheduler();
    }
    this.close();
  }

  public async deleteItem(item){
      if(confirm("確定要刪除嗎?")== true){
          schedulerModule.removeJob(item.id);
      }else{
          appModule.sendErrorNotice("取消刪除");
      }
  }
  public async resumeItem(item) {
      if(confirm("確定要回復排程嗎?") == true){
          schedulerModule.resumeJob(item.id);
      }else{
          appModule.sendErrorNotice("取消回復排程");
      }
  }
  public async pauseItem(item) {
      if(confirm("確定要暫停排程嗎?") == true){
          schedulerModule.pauseJob(item.id);
      }else{
          appModule.sendErrorNotice("取消暫停");
      }
  }
  public async runItem(item) {
      if(confirm("確定要執行Job嗎?") == true){
          schedulerModule.runJob(item.id);
      }else{
          appModule.sendErrorNotice("取消執行");
      }
  }
  created() {
      schedulerModule.initialScheduler();
  }
}
